const onced = new Map()
export default function consoleOnce(id: string, params: Record<string, any>) {
  if (onced.has(id)) {
    if (Object.is(params, onced.get(id))) {
      return
    }
    return
  }
  onced.set(id, params)
}
